<template>
  <div class="eno-home">
    <!-- 轮播图 -->
    <div class="home-banner">
      <banner />
    </div>
    <!-- 观点 -->
    <div class="home-viewpoint">
      <viewPoint />
    </div>
    <!-- 体系 -->
    <div class="home-system">
      <system />
    </div>
    <!-- 动态效果区域 -->
    <div class="h5_none">
      <dynamicEffects />
    </div>
    <!-- AI智慧管理 -->
    <div >
      <aiSmartMent />
    </div>
    <!-- 方案 -->
    <div class="home-scheme">
      <scheme />
    </div>
    <!-- 客户 -->
    <div class="home-customer ">
      <customer />
    </div>
    <!-- 认证 -->
    <div class="home-auth">
      <auth />
    </div>
    <!-- 预约服务 -->
    <div class="home-auth">
      <appService />
    </div>
  </div>
</template>

<script>
import banner from "./components/banner";
import viewPoint from "./components/viewPoint";
import system from "./components/system";
import scheme from "./components/scheme";
import customer from "./components/customer";
import auth from "./components/auth";
import aiSmartMent from "./components/ai_smart_anagement.vue";
import dynamicEffects from "./components/dynamic_effects.vue";
import appService from "../common/appService.vue";
export default {
  data() {
    return {};
  },
  components: {
    banner,
    viewPoint,
    system,
    scheme,
    customer,
    auth,
    aiSmartMent,
    dynamicEffects, appService
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.eno-home {}
</style>
